import React, { useState } from 'react';
import { GridList, GridListTile, Box } from '@material-ui/core';
import PostImage from './postImage';
import ImagesModal from './imagesModal';
import imgParams from '../../utils/imageUtil';
import useReactRouter from 'use-react-router';
import { useDimensions } from '../../hooks/utilHooks';

const PostImages = ({ images, postShareInfo, isPostDetail, post }) => {
  const postId = post.id;
  const { width, ref } = useDimensions();
  const imageCount = images.length;
  const { history } = useReactRouter();
  const colsMap = {
    0: imageCount === 2 ? 1 : 2,
    1: 1,
    2: 1,
  };
  const rowsMap = {
    0: imageCount > 1 ? 1.2 : 2,
    1: imageCount === 2 ? 1.2 : 1,
    2: 1,
  };
  const [open, setOpen] = React.useState(false);
  const [imagePosition, setImagePosition] = useState(0);

  open && history.action === 'POP' && setOpen(false);
  const handleOpen = (e, imagePosition) => {
    e.stopPropagation();
    // !open && history.push(history.location.pathname);
    !open && history.push(post.slug, { postId });
    setImagePosition(imagePosition);
    setOpen(true);
  };

  const handleClose = (e) => {
    e.stopPropagation();
    history.goBack();
  };
  return (
    <Box pb={2}>
      <Box className="overflowHidden" px={4}>
        {images.length > 1 && (
          <GridList spacing={2} cellHeight={160} rows={1} cols={2}>
            {images.slice(0, 3).map((image, index) => (
              <GridListTile
                onClick={(e) => handleOpen(e, index)}
                key={image.id}
                rows={rowsMap[index]}
                cols={colsMap[index]}
              >
                <PostImage
                  image={imgParams(image.src, 720)}
                  imagePosition={index}
                  imageCount={images.length}
                />
              </GridListTile>
            ))}
          </GridList>
        )}
      </Box>

      {images.length === 1 && (
        <Box
          px={4}
          className="postSingleImg"
          height={!isPostDetail ? '340px' : 'auto'}
        >
          {images.map((image, index) => (
            <img
              ref={ref}
              onClick={(e) => handleOpen(e, index)}
              src={imgParams(image.src, width * 2, !isPostDetail && 340 * 2)}
              alt="img"
              key={index}
            />
          ))}
        </Box>
      )}
      <ImagesModal
        selectedImagePosition={imagePosition}
        handleClose={handleClose}
        openModal={open}
        images={images}
        postShareInfo={postShareInfo}
      />
    </Box>
  );
};

export default PostImages;
